import PartnerBanks from "@/components/landing/PartnerBanks";
import { useCallback } from "react";
import SEO from "@/components/common/SEO";
import { LOAN_TYPES } from "@/constants/loanTypes";

import LoanLayout from "@/components/loans/LoanLayout";
import LoanHero from "@/components/loans/LoanHero";
import LoanOverview from "@/components/loans/LoanOverview";
import LoanBenefits from "@/components/loans/LoanBenefits";
import LoanTypes from "@/components/loans/LoanTypes";
import LoanEligibility from "@/components/loans/LoanEligibility";
import LoanDocuments from "@/components/loans/LoanDocuments";
import LoanProcess from "@/components/loans/LoanProcess";
import WhyMoneyMart from "@/components/loans/WhyMoneyMart";
import LoanFAQ from "@/components/loans/LoanFAQ";
import LoanCTA from "@/components/loans/LoanCTA";
import LeadFormSection from "@/components/loans/LeadFormSection";

import { takeoverTopUp } from "@/data/loans";

const TakeoverTopUp = () => {
  const scrollToLeadForm = useCallback(() => {
    const el = document.getElementById("lead-form");

    if (el) {
      el.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }, []);

  return (
    <>
      <SEO {...takeoverTopUp.seo} />
      <LoanLayout onCtaClick={scrollToLeadForm}>
        <LoanHero
          {...takeoverTopUp.hero}
          onPrimaryClick={scrollToLeadForm}
          onSecondaryClick={scrollToLeadForm}
        />

        <LoanOverview {...takeoverTopUp.overview} />

        <LoanBenefits {...takeoverTopUp.benefits} />

        <LoanTypes {...takeoverTopUp.types} />

        <LoanEligibility
          {...takeoverTopUp.eligibility}
          onCheckEligibility={scrollToLeadForm}
        />

        <LoanDocuments {...takeoverTopUp.documents} />

        <LoanProcess {...takeoverTopUp.process} />

        <WhyMoneyMart {...takeoverTopUp.whyMoneyMart} />

        <PartnerBanks />

        <LoanFAQ {...takeoverTopUp.faq} />

        <LoanCTA {...takeoverTopUp.cta} onApply={scrollToLeadForm} />

        <LeadFormSection
          {...takeoverTopUp.leadForm}
          loanType="TAKEOVER_TOPUP"
        />
      </LoanLayout>
    </>
  );
};

export default TakeoverTopUp;
